// import { useDispatch } from 'react-redux';

import CompanyTable from 'pages/Companies/CompanyTable';

const ClientCompaniesTable = ({ data, pagination }) => {
  // const dispatch = useDispatch();

  // const onChangePerPage = (per_page) => {
  //   dispatch(
  //     setParams({
  //       per_page,
  //       page: 1,
  //     })
  //   );
  //   dispatch(getCompanies());
  // };

  // const onChangePage = ({ selected }) => {
  //   dispatch(
  //     setParams({
  //       page: selected + 1,
  //     })
  //   );
  //   dispatch(getCompanies());
  // };

  return <CompanyTable data={data} pagination={pagination}></CompanyTable>;
};

export default ClientCompaniesTable;
